export let BillingScheduleGroupType = /*#__PURE__*/function (BillingScheduleGroupType) {
  BillingScheduleGroupType["Today"] = "today";
  BillingScheduleGroupType["OnRelationshipEffectiveDate"] = "onRelationshipEffectiveDate";
  BillingScheduleGroupType["BilledOnStages"] = "billedOnStages";
  BillingScheduleGroupType["Weekly"] = "weekly";
  BillingScheduleGroupType["Biweekly"] = "biweekly";
  BillingScheduleGroupType["Monthly"] = "monthly";
  BillingScheduleGroupType["Quarterly"] = "quarterly";
  BillingScheduleGroupType["Yearly"] = "yearly";
  BillingScheduleGroupType["Paused"] = "paused";
  BillingScheduleGroupType["WeeklyPaused"] = "weeklyPaused";
  BillingScheduleGroupType["BiweeklyPaused"] = "biweeklyPaused";
  BillingScheduleGroupType["MonthlyPaused"] = "monthlyPaused";
  BillingScheduleGroupType["QuarterlyPaused"] = "quarterlyPaused";
  return BillingScheduleGroupType;
}({});